// extracted by mini-css-extract-plugin
module.exports = {"small-input":"FormattedInput_small-input__b17eH"};